// type safe version of Object.entries

import type { AnyObject } from '#types'

type Entries<T> = {
  [K in keyof T]: [K, T[K]]
}[keyof T][]

export const entries = <T extends AnyObject>(obj: T): Entries<T> => {
  return Object.entries(obj) as Entries<T>
}

type Values<T> = T[keyof T][]

export const values = <T extends AnyObject>(obj: T): Values<T> => {
  return Object.values(obj) as Values<T>
}

export const assertNever = (q: never): never => {
  throw new Error(`Unexpected object: ${q}`)
}
